import React from "react";
import { useNavigate } from "react-router-dom";

const PelvisHipsBackPT = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .phb-page {
          min-height: 100vh;
          width: 100%;
          background: radial-gradient(circle at top left, #fdf2ff 0, #f9fafb 40%, #e5e7eb 100%);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #0f172a;
        }

        .phb-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 16px 72px;
        }

        /* HERO */
        .phb-hero {
          padding: 26px 22px 34px;
          border-radius: 28px;
          background: linear-gradient(120deg, rgba(168, 85, 247, 0.18), rgba(56, 189, 248, 0.1));
          margin-bottom: 36px;
          display: grid;
          grid-template-columns: minmax(0, 1.5fr) minmax(0, 1.1fr);
          gap: 24px;
          align-items: center;
        }

        @media (max-width: 820px) {
          .phb-hero {
            grid-template-columns: 1fr;
          }
        }

        .phb-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 5px 12px;
          border-radius: 999px;
          background: rgba(168, 85, 247, 0.22);
          color: #6b21a8;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 8px;
        }

        .phb-tagDot {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: #a855f7;
        }

        .phb-title {
          font-size: clamp(28px, 4vw, 38px);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 10px;
        }

        .phb-subtitle {
          font-size: 15px;
          max-width: 560px;
          color: #374151;
        }

        .phb-chips {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 16px 0 18px;
        }

        .phb-chip {
          padding: 6px 12px;
          border-radius: 999px;
          background: #0f172a;
          color: #f9fafb;
          font-size: 11px;
        }

        .phb-ctaRow {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 10px;
        }

        .phb-btnPrimary,
        .phb-btnSecondary {
          border-radius: 999px;
          border: none;
          font-size: 14px;
          padding: 9px 18px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;
        }

        .phb-btnPrimary {
          background: #a855f7;
          color: #fdf4ff;
          box-shadow: 0 10px 24px rgba(168, 85, 247, 0.4);
        }

        .phb-btnPrimary:hover {
          transform: translateY(-1px);
          box-shadow: 0 14px 32px rgba(168, 85, 247, 0.55);
        }

        .phb-btnSecondary {
          background: rgba(15, 23, 42, 0.06);
          color: #111827;
          border: 1px solid rgba(148, 163, 184, 0.7);
        }

        .phb-btnSecondary:hover {
          background: rgba(15, 23, 42, 0.1);
          transform: translateY(-1px);
        }

        .phb-heroImgWrap {
          display: flex;
          justify-content: center;
        }

        .phb-heroImg {
          width: 100%;
          max-width: 380px;
          border-radius: 24px;
          object-fit: cover;
          box-shadow: 0 18px 38px rgba(15, 23, 42, 0.24);
        }

        /* GENERIC SECTIONS */
        .phb-stripe {
          padding: 32px 0;
          border-bottom: 1px solid rgba(148, 163, 184, 0.35);
        }

        .phb-sectionTitle {
          font-size: 21px;
          font-weight: 800;
          margin-bottom: 8px;
        }

        .phb-sectionSubtitle {
          font-size: 14px;
          color: #4b5563;
          margin-bottom: 18px;
        }

        .phb-flexRow {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          align-items: center;
        }

        .phb-flexCol {
          flex: 1 1 260px;
        }

        .phb-img {
          width: 100%;
          max-width: 360px;
          border-radius: 22px;
          object-fit: cover;
          box-shadow: 0 14px 30px rgba(15, 23, 42, 0.18);
        }

        /* LISTS */
        .phb-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          gap: 8px;
        }

        .phb-list li {
          display: flex;
          gap: 8px;
          font-size: 14px;
          color: #111827;
        }

        .phb-bullet {
          width: 7px;
          height: 7px;
          border-radius: 999px;
          background: #a855f7;
          margin-top: 6px;
          flex-shrink: 0;
        }

        /* CARD GRID */
        .phb-cardGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 16px;
          margin-top: 18px;
        }

        .phb-card {
          padding: 12px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.02);
          border: 1px solid rgba(148, 163, 184, 0.5);
        }

        .phb-cardTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .phb-cardText {
          font-size: 12px;
          color: #4b5563;
        }

        /* TWO-COLUMN GRID SECTION */
        .phb-twoColGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
          gap: 20px;
          margin-top: 18px;
        }

        .phb-pillBox {
          padding: 14px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.03);
        }

        .phb-pillTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 6px;
        }

        .phb-pillText {
          font-size: 13px;
          color: #4b5563;
        }

        /* BANNER */
        .phb-banner {
          position: relative;
          border-radius: 26px;
          overflow: hidden;
          margin-top: 24px;
        }

        .phb-banner img {
          width: 100%;
          height: 240px;
          object-fit: cover;
          display: block;
        }

        @media (min-width: 768px) {
          .phb-banner img {
            height: 270px;
          }
        }

        .phb-bannerOverlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(15, 23, 42, 0.82), transparent 60%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 18px 20px;
          gap: 10px;
        }

        .phb-bannerText {
          color: #f5f3ff;
          font-size: 15px;
          max-width: 420px;
        }

        .phb-bannerButtons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .phb-bannerButtons button {
          font-size: 12px;
          padding: 8px 14px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .phb-bannerButtons .primary {
          background: #a855f7;
          color: #fdf4ff;
        }

        .phb-bannerButtons .secondary {
          background: rgba(255,255,255,0.18);
          color: #f9fafb;
          border: 1px solid rgba(255,255,255,0.6);
        }

        /* BOTTOM STRIP */
        .phb-bottomStrip {
          margin-top: 24px;
          padding: 14px 14px;
          border-radius: 22px;
          background: #0f172a;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          align-items: center;
          justify-content: space-between;
        }

        .phb-bottomText {
          font-size: 12px;
          color: #e5e7eb;
          flex: 1 1 240px;
        }

        .phb-bottomText strong {
          color: #f5f3ff;
        }

        .phb-bottomActions {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .phb-bottomActions button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .phb-bottomActions .primary {
          background: #a855f7;
          color: #fdf4ff;
        }

        .phb-bottomActions .secondary {
          background: transparent;
          color: #e5e7eb;
          border: 1px solid rgba(148, 163, 184, 0.8);
        }

        @media (max-width: 640px) {
          .phb-title {
            font-size: 26px;
          }
        }
      `}</style>

      <div className="phb-page">
        <div className="phb-inner">
          {/* HERO */}
          <section className="phb-hero">
            <div>
              <div className="phb-tag">
                <span className="phb-tagDot" />
                Pelvis & Hips · Back
              </div>
              <h1 className="phb-title">
                Support your hips and pelvis so walking, standing, and sitting feel more balanced.
              </h1>
              <p className="phb-subtitle">
                The back of your pelvis and hips—glutes, deep hip muscles, and the hip joints themselves—
                help transfer force between your spine and legs. When they&apos;re irritated, everyday movements
                can feel tight, achy, or unsteady.
              </p>

              <div className="phb-chips">
                <span className="phb-chip">Hip & buttock soreness</span>
                <span className="phb-chip">Outer hip pain</span>
                <span className="phb-chip">Deep glute & piriformis tension</span>
                <span className="phb-chip">IT band tightness</span>
              </div>

              <div className="phb-ctaRow">
                <button
                  className="phb-btnPrimary"
                  onClick={() => navigate("/appointments")}
                >
                  Book a pelvis & hip visit →
                </button>
                <button
                  className="phb-btnSecondary"
                  onClick={() => navigate("/staff")}
                >
                  Meet our therapists
                </button>
              </div>
            </div>

            <div className="phb-heroImgWrap">
              <img
                src="/content/pelvis-hips-back/pelvis_hips_back_hero.png"
                alt="Therapist assessing pelvis and hips from the back"
                className="phb-heroImg"
              />
            </div>
          </section>

          {/* WHAT CAN GO WRONG */}
          <section className="phb-stripe">
            <div className="phb-sectionTitle">What can go wrong around the back of the pelvis & hips?</div>
            <p className="phb-sectionSubtitle">
              The hip joints, glute muscles, deep rotators, and IT band share the work of stabilizing your pelvis
              while you stand, walk, and change direction. When they&apos;re overloaded or under-supported,
              they can signal with discomfort or stiffness.
            </p>

            <div className="phb-flexRow">
              <div className="phb-flexCol">
                <ul className="phb-list">
                  <li>
                    <span className="phb-bullet" />
                    <span>
                      Aching or tightness in the buttock region with walking, standing, or climbing stairs.
                    </span>
                  </li>
                  <li>
                    <span className="phb-bullet" />
                    <span>
                      Outer hip pain or tenderness when lying on your side or standing on one leg.
                    </span>
                  </li>
                  <li>
                    <span className="phb-bullet" />
                    <span>
                      Deep glute or piriformis tension that may feel like a deep “knot” in the hip area.
                    </span>
                  </li>
                  <li>
                    <span className="phb-bullet" />
                    <span>
                      Tightness along the outside of the thigh that worsens with running or long walks (IT band).
                    </span>
                  </li>
                  <li>
                    <span className="phb-bullet" />
                    <span>
                      Hip fatigue or stiffness after prolonged sitting, especially when standing up.
                    </span>
                  </li>
                </ul>

                <div className="phb-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="phb-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    See if this sounds like you →
                  </button>
                  <button
                    className="phb-btnSecondary"
                    onClick={() => navigate("/contact")}
                  >
                    Ask a quick question
                  </button>
                </div>
              </div>

              <div className="phb-flexCol" style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src="/content/pelvis-hips-back/pelvis_gluteus_maximus.png"
                  alt="Manual therapy on gluteal region"
                  className="phb-img"
                />
              </div>
            </div>

            <div className="phb-cardGrid">
              <div className="phb-card">
                <div className="phb-cardTitle">Hip Joint</div>
                <div className="phb-cardText">
                  The ball-and-socket joint of the upper thigh that supports standing, walking, and squatting.
                </div>
              </div>
              <div className="phb-card">
                <div className="phb-cardTitle">Gluteus Maximus</div>
                <div className="phb-cardText">
                  The main hip extensor that helps you stand up, climb, and control powerful movements.
                </div>
              </div>
              <div className="phb-card">
                <div className="phb-cardTitle">Gluteus Medius & Minimus</div>
                <div className="phb-cardText">
                  Outer and deep hip muscles that stabilize the pelvis, especially when standing on one leg.
                </div>
              </div>
              <div className="phb-card">
                <div className="phb-cardTitle">Piriformis & Deep Rotators</div>
                <div className="phb-cardText">
                  Deep muscles that help rotate and stabilize the hip, especially during turning and stepping.
                </div>
              </div>
            </div>
          </section>

          {/* OUTER HIP / GLUTE MEDIUS */}
          <section className="phb-stripe">
            <div className="phb-flexRow">
              <div className="phb-flexCol">
                <img
                  src="/content/pelvis-hips-back/pelvis_gluteus_medius.png"
                  alt="Therapist treating outer hip / gluteus medius"
                  className="phb-img"
                />
              </div>

              <div className="phb-flexCol">
                <div className="phb-sectionTitle">Outer hip and side-lying discomfort</div>
                <p className="phb-sectionSubtitle">
                  The gluteus medius and minimus help keep your pelvis level when you walk. If they&apos;re irritated
                  or weak, your outer hip may complain.
                </p>

                <ul className="phb-list">
                  <li>
                    <span className="phb-bullet" />
                    <span>
                      Pain or tenderness over the outer hip when lying on that side.
                    </span>
                  </li>
                  <li>
                    <span className="phb-bullet" />
                    <span>
                      Discomfort standing on one leg, like when putting on pants or stepping off a curb.
                    </span>
                  </li>
                  <li>
                    <span className="phb-bullet" />
                    <span>
                      Hip fatigue or soreness after longer walks or runs.
                    </span>
                  </li>
                </ul>

                <div className="phb-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="phb-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Start pelvis & hip PT →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* PIRIFORMIS & DEEP GLUTE */}
          <section className="phb-stripe">
            <div className="phb-flexRow">
              <div className="phb-flexCol">
                <div className="phb-sectionTitle">Deep glute and piriformis tension</div>
                <p className="phb-sectionSubtitle">
                  Deep hip muscles like the piriformis help rotate and steady the leg. When they&apos;re tight
                  or overactive, they can feel like a deep, pinpoint ache in the back of the hip.
                </p>

                <ul className="phb-list">
                  <li>
                    <span className="phb-bullet" />
                    <span>
                      Deep buttock discomfort with sitting, especially on firm chairs, or after driving.
                    </span>
                  </li>
                  <li>
                    <span className="phb-bullet" />
                    <span>
                      Tightness when crossing one leg over the other or rotating the hip.
                    </span>
                  </li>
                  <li>
                    <span className="phb-bullet" />
                    <span>
                      A feeling that the hip is “locked” until you move and warm up.
                    </span>
                  </li>
                </ul>

                <div className="phb-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="phb-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Book a hip-focused session →
                  </button>
                  <button
                    className="phb-btnSecondary"
                    onClick={() => navigate("/insurance")}
                  >
                    Check my insurance
                  </button>
                </div>
              </div>

              <div className="phb-flexCol">
                <img
                  src="/content/pelvis-hips-back/pelvis_piriformis.png"
                  alt="Therapist working on deep glute / piriformis region"
                  className="phb-img"
                />
              </div>
            </div>
          </section>

          {/* HOW PT HELPS */}
          <section className="phb-stripe">
            <div className="phb-sectionTitle">How physical therapy supports the pelvis & hips</div>
            <p className="phb-sectionSubtitle">
              We look at how your hips, pelvis, core, and legs share the workload, then build a plan that fits your
              comfort level and activity goals.
            </p>

            <div className="phb-twoColGrid">
              <div className="phb-pillBox">
                <div className="phb-pillTitle">Hands-on hip & glute treatment</div>
                <div className="phb-pillText">
                  Soft-tissue work and joint techniques to help calm irritated areas and restore motion.
                </div>
              </div>
              <div className="phb-pillBox">
                <div className="phb-pillTitle">Strength for hips & pelvis</div>
                <div className="phb-pillText">
                  Targeted exercises for glutes, deep hip rotators, and core to better support the pelvis.
                </div>
              </div>
              <div className="phb-pillBox">
                <div className="phb-pillTitle">Gait & movement coaching</div>
                <div className="phb-pillText">
                  Guidance on how you walk, squat, and climb so your hips aren&apos;t doing all the work alone.
                </div>
              </div>
              <div className="phb-pillBox">
                <div className="phb-pillTitle">Position & pacing strategies</div>
                <div className="phb-pillText">
                  Practical tips for sitting, standing, and activity changes that let irritated tissues calm down.
                </div>
              </div>
            </div>

            <div className="phb-ctaRow" style={{ marginTop: "18px" }}>
              <button
                className="phb-btnPrimary"
                onClick={() => navigate("/appointments")}
              >
                Book a pelvis & hip visit →
              </button>
              <button
                className="phb-btnSecondary"
                onClick={() => navigate("/office")}
              >
                View locations
              </button>
            </div>
          </section>

          {/* EXERCISES / VISIT FLOW */}
          <section className="phb-stripe">
            <div className="phb-flexRow">
              <div className="phb-flexCol">
                <img
                  src="/content/pelvis-hips-back/pelvis_back_strength.png"
                  alt="Patient doing hip and glute strengthening with therapist"
                  className="phb-img"
                />
              </div>

              <div className="phb-flexCol">
                <div className="phb-sectionTitle">What a pelvis & hips (back) visit may look like</div>

                <div className="phb-twoColGrid">
                  <div className="phb-pillBox">
                    <div className="phb-pillTitle">1. Your story</div>
                    <div className="phb-pillText">
                      We talk about when your hip or pelvis symptoms show up, what makes them better or worse,
                      and what you want to get back to.
                    </div>
                  </div>
                  <div className="phb-pillBox">
                    <div className="phb-pillTitle">2. Motion & strength check</div>
                    <div className="phb-pillText">
                      We gently test hip motion, pelvic control, and how your spine and legs are contributing.
                    </div>
                  </div>
                  <div className="phb-pillBox">
                    <div className="phb-pillTitle">3. Hands-on care</div>
                    <div className="phb-pillText">
                      You try specific manual techniques and movements to see what calms symptoms and improves motion.
                    </div>
                  </div>
                  <div className="phb-pillBox">
                    <div className="phb-pillTitle">4. Simple home plan</div>
                    <div className="phb-pillText">
                      You leave with a small, doable set of exercises and strategies—not a long list to memorize.
                    </div>
                  </div>
                </div>

                <div className="phb-ctaRow" style={{ marginTop: "16px" }}>
                  <button
                    className="phb-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Book a pelvis & hip evaluation →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* BANNER */}
          <section className="phb-stripe">
            <div className="phb-banner">
              <img
                src="/content/pelvis-hips-back/pelvis_back_banner.png"
                alt="Bright PT clinic environment for pelvis and hip care"
              />
              <div className="phb-bannerOverlay">
                <div className="phb-bannerText">
                  Pelvis and hip sessions happen in a calm, one-on-one setting where we match your plan to
                  your comfort level, work demands, and daily life.
                </div>
                <div className="phb-bannerButtons">
                  <button
                    className="primary"
                    onClick={() => navigate("/appointments")}
                  >
                    Schedule a pelvis & hip visit →
                  </button>
                  <button
                    className="secondary"
                    onClick={() => navigate("/office")}
                  >
                    View locations
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* SAFETY NOTE */}
          <section className="phb-stripe">
            <div className="phb-bottomStrip">
              <div className="phb-bottomText">
                If you notice sudden severe hip or pelvic pain after a fall, can&apos;t put weight on the leg,
                have loss of bladder or bowel control, fever with unexplained pain, or symptoms that feel very
                different than usual, <strong>seek urgent or emergency medical care first.</strong> Physical therapy
                can then help you safely rebuild comfort and strength once serious causes are ruled out.
              </div>
              <div className="phb-bottomActions">
                <button
                  className="primary"
                  onClick={() => navigate("/appointments")}
                >
                  Schedule pelvis & hip PT
                </button>
                <button
                  className="secondary"
                  onClick={() => navigate("/contact")}
                >
                  Message our team
                </button>
              </div>
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default PelvisHipsBackPT;
